var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Container, Col, Row } from "../../grid";
import { Tabs, Tab } from "../../tabs";
import { BackwardButton } from "../../button";
import { Divider } from "../../divider";
import hash from "object-hash";
import { Wrapper, FlyoutWrapper, TitleWrapper, StyledTypo, StyledButtonWrapper, } from "./LanguageSwitch.styles";
// utils
import { makeDataTestIdGetter } from "../../utils";
export function LanguageSwitch(_a) {
    var { languages, onClick, currentLanguage, backLinkText, title, dataTestIdPrefix } = _a, previewProps = __rest(_a, ["languages", "onClick", "currentLanguage", "backLinkText", "title", "dataTestIdPrefix"]);
    const [flyoutOpen, setFlyoutOpen] = useState(false);
    const [removeSelectedTabIndex, setRemoveSelectedTabIndex] = useState(true);
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    useEffect(() => {
        const menuBarWrapper = document.querySelector(".menu-bar");
        if (flyoutOpen) {
            setRemoveSelectedTabIndex(false);
            if (menuBarWrapper)
                menuBarWrapper.style.overflow = "hidden";
        }
        else {
            setRemoveSelectedTabIndex(true);
            if (menuBarWrapper)
                menuBarWrapper.style.overflow = "auto";
        }
    }, [flyoutOpen]);
    function toggleFlyout() {
        setFlyoutOpen(!flyoutOpen);
    }
    if ((languages === null || languages === void 0 ? void 0 : languages.length) <= 1)
        return null;
    return (_jsxs(Wrapper, { children: [_jsx(Tabs, Object.assign({}, previewProps, { initialSelected: 1, alignment: "vertical", onTabChange: toggleFlyout, removeSelectedTabIndex: removeSelectedTabIndex, "data-testid": getDataTestId("tabs") }, { children: _jsx(Tab, { title: currentLanguage, symbol: "chevron_right" }) })), languages && languages.length && flyoutOpen && (_jsx(FlyoutWrapper, { children: _jsx(Container, { children: _jsx(Row, { children: _jsxs(Col, { children: [_jsx(StyledButtonWrapper, { children: _jsx(BackwardButton, Object.assign({ onClick: toggleFlyout, size: "small", symbol: "chevron_left", stylingType: "flat" }, { children: backLinkText })) }), _jsxs(TitleWrapper, { children: [_jsx(StyledTypo, Object.assign({ variant: "p2" }, { children: title })), _jsx(Divider, {})] }), _jsx(Tabs, Object.assign({}, previewProps, { initialSelected: languages.indexOf(currentLanguage), alignment: "vertical", onTabChange: (selected) => {
                                        if (typeof onClick === "function") {
                                            onClick(selected);
                                            setFlyoutOpen(false);
                                        }
                                    }, stylingType: "withIcon" }, { children: languages.map((lang) => (_jsx(Tab, { title: lang, symbol: "Checkmark" }, hash(lang)))) }))] }) }) }) }))] }));
}
